<span>
  Une interruption technique temporaire perturbe actuellement l'accès à votre application. <br />
  Nos équipes sont mobilisées pour résoudre la situation au plus vite. <br />
  Merci pour votre compréhension.</span
>

<div class="actions-container">
  <oui-button
    size="large"
    iconSuffix="autorenew"
    (click)="reloadPage()"
    >Recharger la page
  </oui-button>
</div>
